import {
  CategoryStatus,
  GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category,
  GetArticleQuery_query_article_Article_events_ArticleEvent,
} from '../../../../__generated__/queries-web';

export interface GetArticleEvent {
  order: number;
  id: string;
  title: string;
  status?: CategoryStatus;
}

export const getArticleEvent = ({
  order,
  id,
  title,
  status,
}: GetArticleEvent): GetArticleQuery_query_article_Article_events_ArticleEvent => ({
  __typename: 'ArticleEvent',
  order,
  category: {
    __typename: 'Category',
    id,
    title,
    status,
  } as GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category,
});
